import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Row, Select, TextField, H5 } from '@fs/zion-ui'
import { getPerson } from '../../../services/personService'

export default function AddPerson({
  editableTemplePlatform,
  setEditableTemplePlatform,
  editableCtrExtendedDetail,
  setEditableCtrExtendedDetail,
}) {
  const { t } = useTranslation()
  const [role, setRole] = useState('')
  const [personId, setPersonId] = useState('')
  const roles = ['Father', 'Mother', 'Wife']
  const roleOptions = roles
    .filter((option) => !Object.prototype.hasOwnProperty.call(editableCtrExtendedDetail, option.toLowerCase()))
    .map((type) => {
      return {
        value: type.toLowerCase(),
        label: type,
      }
    })

  const addAPersonOnClick = async () => {
    const person = await getPerson(personId, true)
    if (person) {
      const resourceId = `${editableCtrExtendedDetail.principal.resourceId}-${role}`
      const newPerson = {
        id: resourceId,
        gender: person.genderConclusion.value,
        identifiers: {
          'http://api.familysearch.org/temple/USYS_ID': [`p.${person.id}`],
        },
        living: false,
        names: [person.nameConclusion.value],
      }
      const newTemplePlatform = { ...editableTemplePlatform }
      newTemplePlatform.persons.push(newPerson)
      setEditableTemplePlatform(newTemplePlatform)
      const newCtrExtendedDetail = { ...editableCtrExtendedDetail }
      newCtrExtendedDetail[role] = {
        resource: `#${resourceId}`,
        resourceId,
      }
      setEditableCtrExtendedDetail(newCtrExtendedDetail)
      setRole('')
      setPersonId('')
    }
  }

  return (
    <>
      {roleOptions.length > 0 && (
        <>
          <H5>{t('ctr.summary.headings.addAPerson', 'Add A Person')}</H5>
          <Row>
            <Select
              label={t('role.label', 'Role')}
              value={role}
              placeholder={t('ctr.summary.selectRole', 'Select Role')}
              onChange={(e) => setRole(e.target.value)}
              options={roleOptions}
            />
            <TextField
              label={t('personId', 'Person ID')}
              value={personId}
              onChange={(e) => setPersonId(e.target.value)}
            />
            <Button disabled={!role || !personId} emphasis="high" onClick={addAPersonOnClick} alignY="nextToInput">
              {t('action.add', 'Add')}
            </Button>
          </Row>
        </>
      )}
    </>
  )
}
